import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredSubscription = false, requireProfileComplete = true }) => {
  const { user, userProfile, loading, profileLoading } = useAuth();

  if (loading || (requireProfileComplete && user && profileLoading)) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-2 border-brand-pink border-t-transparent mx-auto mb-4" />
          <p className="text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (userProfile?.isBlocked === true || userProfile?.is_blocked === true) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
        <div className="text-center max-w-md">
          <h1 className="font-heading font-bold text-xl text-white mb-2">Account restricted</h1>
          <p className="text-slate-400">Your account has been restricted. Contact support if you believe this is an error.</p>
        </div>
      </div>
    );
  }

  if (requireProfileComplete) {
    const isMigrated = userProfile?.isMigratedUser === true;
    const profileRecompleted = userProfile?.profileRecompletedAt != null;
    const onboardingCompleted = userProfile?.onboardingCompletedAt != null;
    if (isMigrated && !profileRecompleted) {
      return <Navigate to="/onboarding/recreate-profile" replace />;
    }
    if (!isMigrated && !onboardingCompleted) {
      return <Navigate to="/onboarding" replace />;
    }
  }

  if (requiredSubscription) {
    const status = userProfile?.subscriptionStatus ?? userProfile?.subscription_status ?? 'free';
    const active = ['premium', 'active', 'trialing'].includes(String(status).toLowerCase());
    if (!active) {
      return <Navigate to="/payment" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
